<div class="container" style="display:flex; flex-direction: column; height: 90%;">

  <div class="row justify-content-center" style="margin-top: 20px;">

    <div class="col">
      <img src="../../assets/images/noaa-emblem-rgb-withspace-2022.png" class="center" height="130" width="130" />
    </div>

    <div class="col">
      <img src="../../assets/images/PSMFCLogo.png" class="center" height="130" width="130" />
    </div>

  </div>

  <div class="row justify-content-center" style="margin-top: 15px;">
    <div class="col">
      <img src="../../assets/images/FishVueFloat FullColour Horizontal.png" class="center" style="height: auto; max-width: 100%; width: 225px;" />
    </div>
  </div>

  <h1 class="display-6" style="padding-top: 15px; font-weight: bold; font-size: 28px;" align="center">Which Vessel(s) do you operate?</h1>
  <h3 class="display-6" style="background-color: #005d87; color: white; font-style: italic;" align="center">Vessels may be added/edited within app</h3>


  <mat-toolbar style="background-color: #005d87; color: white;">
    <span>Vessel</span>
    <span class="example-spacer"></span>

    <!-- Add Vessel -->
    <button mat-mini-fab
            class="blue-icon-button"
            type="button"
            matTooltip="Add Vessel"
            matTooltipPosition="below"
            (click)="onAddVesselBtnClick(addedVessels.length, false)">
      <mat-icon>
        add
      </mat-icon>
    </button>
  </mat-toolbar>

  <mat-selection-list #vessels [multiple]="false" hideSingleSelectionIndicator="true">
    <div *ngFor="let vessel of addedVessels; let index=index;">
      <mat-list-option (click)="onAddVesselBtnClick(index, true)">
        <span style="display: flex; justify-content:space-between;">
          {{vessel.vesselName}} - {{vessel.vesselCoastNumber}}
        </span>
      </mat-list-option>
      <mat-divider></mat-divider>
    </div>
  </mat-selection-list>

  <div class="row"
       style="margin-top: auto; margin-right: 5px; margin-left: 5px;">

    <!-- Confirm no vessels -->
    <button mat-stroked-button
            *ngIf="addedVessels.length === 0"
            class="color-button-orange pad-button"
            type="submit"
            aria-label="confirm"
            (click)="onConfirmBtnClick()">
      Skip
      <mat-icon>
        arrow_forward
      </mat-icon>
    </button>

    <!-- Confirm added vessels -->
    <button mat-stroked-button
            *ngIf="addedVessels.length > 0"
            class="color-button-orange pad-button"
            type="submit"
            aria-label="confirm"
            (click)="onConfirmBtnClick()">
      Confirm
      <mat-icon>
        arrow_forward
      </mat-icon>
    </button>
  </div>

</div>
